import axios from 'axios';
import { destructureAxiosReq, getDeviceInfo } from 'shared/lib/utils';
import { purchase } from '../api';

/**
 * Get airlines list.
 */
export function getAirlines() {
  return destructureAxiosReq(
    axios.get(
      `${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/info/airlines`
    )
  );
}

/**
 * Get baggage plans.
 *
 * @param {String} lat The latitude coordinate of the user.
 * @param {String} lng The longitude coordinate of the user.
 */
export function getBaggagePlansView(lat, lng) {
  const browserEnv = Object.assign({ lat, lng }, getDeviceInfo());
  return destructureAxiosReq(
    axios.post(
      `${
        process.env.REACT_APP_SURE_API_BASE_URL
      }/api/user/v2/protections/baggage/plans`,
      {},
      {
        headers: {
          'X-Environment': JSON.stringify(browserEnv),
        },
      }
    )
  );
}

/**
 * Get baggage checkout.
 *
 * @param {Object} opts The options object.
 * @param {String} opts.lat The latitude coordinate of the user.
 * @param {String} opts.lng The longitude coordinate of the user.
 * @param {String} opts.planId The selected baggage plan ID.
 * @param {String} opts.airline The airline FS code.
 * @param {String} opts.firstName The passenger's first name.
 * @param {String} [opts.middleName] The passenger's middle name.
 * @param {String} opts.lastName The passenger's last name.
 * @param {String} opts.email The passenger's email.
 * @param {String} opts.phone The passenger's phone number.
 * @param {String} opts.confirmationNumber The flight PNR/confirmation number.
 */
export function getBaggageCheckout(opts = {}) {
  const browserEnv = Object.assign(
    { lat: opts.lat, lng: opts.lng },
    getDeviceInfo()
  );
  const payload = {
    plan_id: opts.planId,
    details: {
      airline_fs_code: opts.airline,
      pax_email: opts.email,
      pax_first_name: opts.firstName,
      pax_middle_name: opts.middleName,
      pax_last_name: opts.lastName,
      pax_phone: opts.phone,
      pnr_code: `${opts.confirmationNumber}`,
    },
  };

  return destructureAxiosReq(
    axios.post(
      `${
        process.env.REACT_APP_SURE_API_BASE_URL
      }/api/user/v2.1/protections/baggage/checkout`,
      payload,
      {
        headers: {
          'X-Environment': JSON.stringify(browserEnv),
        },
      }
    )
  );
}

/**
 * Purchase a baggage policy.
 *
 * @param {Object} opts The options.
 * @param {String} [opts.authToken] The Sure API auth token.
 * @param {String} opts.planId The selected plan ID.
 * @param {String} opts.planTitle The selected plan titl.
 * @param {String} opts.firstName The user's first name.
 * @param {String} opts.lastName The user's last name.
 * @param {String} opts.email The user's email.
 * @param {Number} opts.lat The user's lat location coordinate.
 * @param {Number} opts.lng The user's lng location coordinate.
 * @param {Object} opts.cardElement The Stripe card element.
 * @param {Number} opts.revenue The total revenue of the purchase.
 */
export function purchaseBaggage(opts) {
  const payload = {
    details: opts.details,
  };

  return purchase({
    planId: opts.planId,
    planTitle: opts.planTitle,
    firstName: opts.firstName,
    lastName: opts.lastName,
    email: opts.email,
    lat: opts.lat,
    lng: opts.lng,
    authToken: opts.authToken,
    cardElement: opts.cardElement,
    revenue: opts.revenue,
    payload,
    prefix: 'BRB',
    verticalCode: 'baggage',
    verticalName: 'Baggage Protection',
    endpoint: '/api/user/v2/protections/baggage/purchase',
  });
}
